function CancelIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none">
      <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" />
      <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

export default CancelIcon;
